////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     17/11/2017
// Description: Stores credentials for log-in
////-------------------------------------------------------------------------------------------
export class Credentials {
    public Username: string = '';
    public Password: string = '';
}



// WEBPACK FOOTER //
// ./src/app/domain/credentials.ts